export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    if (!config.public.appEnv === 'development') {
        return
    }

    const counterId1 = 106077647
    const counterId2 = 48820577

    window.ym = window.ym || function () {
        (window.ym.a = window.ym.a || []).push(arguments)
    }
    window.ym.l = 1 * new Date()

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://mc.yandex.ru/metrika/tag.js'

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode?.insertBefore(script, firstScript)

    window.ym(counterId1, 'init', {
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true
    })

    window.ym(counterId2, 'init', {
        webvisor: true,
        clickmap: true,
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true
    })

    const router = useRouter()
    router.afterEach((to) => {
        window.ym(counterId1, 'hit', to.fullPath)
        window.ym(counterId2, 'hit', to.fullPath)
    })
})
